import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../utils/styles";
import { DocumentName } from "../documents/DocumentName";
import { FileStatus } from "../../atom/FileStatus";
import { TrainingDocument } from "../../../types/components";
import { NoDocuments } from "../../molecules/documents/NoDocuments";

interface TrainingTableProps {
  data?: TrainingDocument[] | null;
}

export const TrainingTable: React.FC<TrainingTableProps> = ({ data }) => {
  const { t } = useTranslation();

  if (!data || data.length === 0) {
    return (
      <div className="p-6">
        <NoDocuments label="No training documents." />
      </div>
    );
  }

  return (
    <table>
      <thead>
        <tr className="font-light text-[16px] h-11 leading-[100%] text-gray-550 border-b border-gray-200">
          <td className="py-3 px-6 w-[520px]">{t("Name")}</td>
          <td className="py-3 px-6 w-[120px]">{t("Year")}</td>
          <td className="py-3 px-6 w-[120px]">{t("Hours")}</td>
          <td className="py-3 px-6 w-[200px]">{t("Status")}</td>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className={cn("", index !== (data?.length ?? 0) - 1 && "border-b border-gray-100")}>
            <td className="px-6 py-4 w-[520px] h-[96px]">
              <DocumentName
                name={item.file?.file_name ?? ""}
                description={undefined}
                file_type={item.file?.file_type}
                optional={false}
              />
            </td>
            <td className="py-4 px-6 w-[120px]">
              <p className="text-[16px]">{item.year || "--"}</p>
            </td>
            <td className="py-4 px-6 w-[120px]">
              <p className="text-[16px]">{item.hours || "--"}</p>
            </td>
            <td className="py-4 px-6 w-[200px]">
              <FileStatus code={item.status.code} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
